
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { useLocation } from "react-router-dom"
import styled from "styled-components"
import { useEffect, useState } from "react"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { showNestedModal } from "../../../features/modal/modalSlice"
import Btn from "../../shared/button/Btn"
import InputTextarea from "../../shared/input/new/InputTextarea"
import ImageUploader from "../../docs/ImageUploader"
import { validateFile } from "../../../helper/docs/validateFile"
import { addShipmentDocument, manageShipmentOperation } from "../../../features/shipmentOperation/shipmentOperationSlice"
import { MdLocationPin } from "react-icons/md";
import InputCheckbox from "../../shared/input/new/InputCheckbox"
import InputRadio from "../../shared/input/shipmentOperation/InputRadio"


const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 580px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .content{
            height: auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 20px 40px;
            margin: 20px 0;
            width: 100%;
            gap: 20px;
            color: ${({theme}) => theme.mainTextColor};

            .top-title{
                font-size: 18px;
                font-weight: var(--font-weight-lg);
            }

            .action-container{
                display: flex;
                flex-direction: column;
                width: 100%;
                gap: 20px;

                .location-wrapper{
                    display: flex;
                    align-items: center;
                    gap: 10px;

                    .location-icon{
                        font-size: 1.4rem;
                    }

                    .location-text{
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-lg);
                    }
                }

                .desc-text{
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-lg);
                }


                    .doc-list{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 30px;
        width: 100%;
        padding: 20px 0;
        overflow: auto;

        .doc-item{
            width: 100%;
            height: 300px;
            border: 1px solid ${({theme}) => theme.mainTextColor};
            border-radius: 10px;
            overflow: hidden;
            
            .doc-item-top{
                width: 100%;
                height: 50px;
                border: 1px solid ${({theme}) => theme.mainBorderColor};
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);

                .action{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;

                        .doc-title{
                            font-size: var(--font-size-md);
                            font-weight: var(--font-weight-xl);
                        }

                        span{

                            &:first-child{
                                width: 60px;
                            }
                        }


                        .delete-btn{
                            font-size: var(--font-size-sm);
                            font-weight: var(--font-weight-lg);
                            /* background-color: var(--color-main); */
                            color: #fff;
                            color: var(--color-main);
                            border: 1px solid var(--color-main);
                            padding: 5px 7px;
                            border-radius: 5px;
                            cursor: pointer;
                            margin-right: 10px;
                            transition: .2s;

                            &:hover{
                                background-color: var(--color-main);
                                color: #fff;
                            }
                        }
                    }
            }
        }

        .new-select-item{
            border-color: red;
            border-width: 2px;

            .new-select-item-top{
                background-color: #ff000040;
            }
        }

    }
            }
            
        }

        .btn-container{
            width: 100%;
            height: 70px;
            display: flex;
            justify-content: center;
            align-items: center;
        }


    }
`

const ShipmentRouteOperationModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()

    const {operationRoute} = useSelector(state => state.shipmentOperation)

    const [desc, setDesc] = useState("")

    const [isSuccess, setIsSuccess] = useState(true)

    const [fileList, setFileList] = useState([
        {
            selectedFile: null,
            loadedBefore: operationRoute.documentOfRoutePoint ? operationRoute.documentOfRoutePoint : null,
            fileTypeName: "Sevk İrsaliyesi",
            staticValue: "Sevk İrsaliyesi"
        },
    ])

    const handleFileSelect = async (index, files) => {
    
      const file = await validateFile({file: files[0], maxSize: 5 * 1024 * 1024, allowedTypes:['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']})
    
      if(file){
        // Tüm kontroller başarılıysa, dosyayı fileList'e ekliyoruz
        const newUploads = [...fileList];
        newUploads[index].selectedFile = file;
        setFileList(newUploads);
      };
    
    }

    const handleFirstSubmit = () => {

        const data = {
            id: operationRoute?.shipmentId,
            routePointId: operationRoute?.id,
            stateOfRoutePoint: operationRoute?.stateOfRoutePoint === 0 ? 1 : 2,
            description: desc,
            successOfRoutePoint: operationRoute.loadOrUnload === 1 ? (isSuccess ? 1 : 2) : 1
        }

        dispatch(manageShipmentOperation(data))
    }

    const handleFileSubmit = async () => {
        
        if(fileList[0].selectedFile){
            dispatch(addShipmentDocument({
                id: operationRoute.shipmentId,
                routePointId: operationRoute.id,
                file: fileList[0].selectedFile
            }));
        }
    }


    


  return (
    <Container>
        <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <div className="content">
                <h3 className="top-title">{operationRoute.stateOfRoutePoint === 0 ? (operationRoute?.loadOrUnload === 0 ? "Yüklemeye Başla" : "Boşaltmaya Başla") : operationRoute.stateOfRoutePoint === 1 ? (operationRoute?.loadOrUnload === 0 ? "Yüklemeyi Tamamla" : "Boşaltmayı Tamamla") : (operationRoute?.loadOrUnload === 0 ? "Yükleme Tamamlandı" : "Boşaltma Tamamlandı")}</h3>

                {
                    //! daha işlem başlamamışsa başlatmak için
                    operationRoute.stateOfRoutePoint === 0 &&
                    <div className="action-container">
                        <div className="location-wrapper">
                            <MdLocationPin className="location-icon"/>
                            <div className="location-text">{operationRoute.location}</div>
                        </div>
                        <Btn handleClick={() => handleFirstSubmit()} width={"180px"} bgColor="#333" borderColor="transparent" color="#fff" padding="10px">{operationRoute?.loadOrUnload === 0 ? "Yüklemeye Başla" : "Boşaltmaya Başla"}</Btn>
                        <p className="desc-text">{`${operationRoute?.loadOrUnload === 0 ? "Yüklemeye başla" : "Boşaltmaya başla"}yabilirsiniz. ${operationRoute?.loadOrUnload === 0 ? "Yüklemeyi" : "Boşaltmayı"} tamamladığınızda yüke ait irsaliyeyi sisteme kaydediniz ve ${operationRoute?.loadOrUnload === 0 ? "yüklemeyi" : "boşaltmayı"} tamamlayınız.`}</p>
                    </div>
                }
                {
                    //! işlem başlamışsa bitirmek için
                    operationRoute.stateOfRoutePoint === 1 &&
                    <div className="action-container">
                        <div className="doc-list">
                            {
                                fileList.map((fileItem, index) => {
                                    let previewSrc;
                                    let isPdf;
                                    if (fileItem.selectedFile) {
                                        isPdf = fileItem.selectedFile.type === "application/pdf"
                                        previewSrc = URL.createObjectURL(fileItem.selectedFile);
            
                                    } else if (fileItem.loadedBefore) {
                                        previewSrc = `${process.env.REACT_APP_API_IMG_URI}${fileItem.loadedBefore}`;
                                    } else {
                                        previewSrc = "question";
                                    }
            
                                    return (
                                        <div className={fileItem.selectedFile ? "new-select-item doc-item" : "doc-item"}>
                                                <div className={fileItem.selectedFile ? "new-select-item-top doc-item-top" : "doc-item-top"}>
                                                {fileItem.selectedFile ? (
                                                    <p>Yeni Seçilen Belge: {fileItem.selectedFile.name} - ({fileItem.fileTypeName})</p>
                                                ) : fileItem.loadedBefore ? (
                                                    <p className="action">
                                                        {/* <span></span> */}
                                                        <h3 className="doc-title">Önceden Yüklenmiş Belge - ({fileItem.fileTypeName})</h3>
                                                        {/* <button className="delete-btn" onClick={() => handleRemoveDoc(fileItem)}>Belgeyi Sil</button> */}
                                                        {/* <button className="delete-btn" onClick={() => {}}>---</button> */}
                                                    </p>
                                                ) : (
                                                    <p>Belge Seçilmedi - ({fileItem.fileTypeName})</p>
                                                )}
                                            </div>
                                            <ImageUploader
                                                previewSrc={previewSrc}
                                                isPdf={isPdf} 
                                                onFileSelect={(files) => handleFileSelect(index, files)} 
                                            />
                                        </div>
                                    )
                                }) 
                            }
                        </div>
                        {
                            fileList[0]?.selectedFile &&
                            <Btn handleClick={() => handleFileSubmit()} width={"180px"} bgColor="#333" borderColor="transparent" color="#fff" padding="10px">Sevk İrsaliyesi Yükle</Btn>
                        }

                        <InputTextarea  data={desc} setData={(e) => setDesc(e.target.value)} labelText={operationRoute?.loadOrUnload === 0 ? "Yüklemeye İlişkin Açıklama" : "Boşaltmaya İlişkin Açıklama"} inputWidth={"100%"} name={"desc"}/>

                        {
                            operationRoute.loadOrUnload === 1 &&
                            <InputRadio data={isSuccess} setData={setIsSuccess} name={"successType"} labelText1={"Hasarsız ve Eksiksiz Teslim Edildi."} labelText2={"Sorunlu (Hasarlı veya Eksik) Teslim Edildi."}/>
                        }
                        
                        <Btn handleClick={() => handleFirstSubmit()} width={"180px"} bgColor="#333" borderColor="transparent" color="#fff" padding="10px">{operationRoute?.loadOrUnload === 0 ? "Yüklemeyi Tamamla" : "Boşaltmayı Tamamla"}</Btn>

                    </div>
                }

                {
                    //! işlem bitmişse belge yüklemek için
                    operationRoute.stateOfRoutePoint === 2 &&
                    <div className="action-container">
                        <div className="doc-list">
                            {
                                fileList.map((fileItem, index) => {
                                    let previewSrc;
                                    let isPdf;
                                    if (fileItem.selectedFile) {
                                        isPdf = fileItem.selectedFile.type === "application/pdf"
                                        previewSrc = URL.createObjectURL(fileItem.selectedFile);
            
                                    } else if (fileItem.loadedBefore) {
                                        previewSrc = `${process.env.REACT_APP_API_IMG_URI}${fileItem.loadedBefore}`;
                                    } else {
                                        previewSrc = "question";
                                    }
            
                                    return (
                                        <div className={fileItem.selectedFile ? "new-select-item doc-item" : "doc-item"}>
                                                <div className={fileItem.selectedFile ? "new-select-item-top doc-item-top" : "doc-item-top"}>
                                                {fileItem.selectedFile ? (
                                                    <p>Yeni Seçilen Belge: {fileItem.selectedFile.name} - ({fileItem.fileTypeName})</p>
                                                ) : fileItem.loadedBefore ? (
                                                    <p className="action">
                                                        {/* <span></span> */}
                                                        <h3 className="doc-title">Önceden Yüklenmiş Belge - ({fileItem.fileTypeName})</h3>
                                                        {/* <button className="delete-btn" onClick={() => handleRemoveDoc(fileItem)}>Belgeyi Sil</button> */}
                                                        {/* <button className="delete-btn" onClick={() => {}}>---</button> */}
                                                    </p>
                                                ) : (
                                                    <p>Belge Seçilmedi - ({fileItem.fileTypeName})</p>
                                                )}
                                            </div>
                                            <ImageUploader
                                                previewSrc={previewSrc}
                                                isPdf={isPdf} 
                                                onFileSelect={(files) => handleFileSelect(index, files)} 
                                            />
                                        </div>
                                    )
                                }) 
                            }
                        </div>
                        {
                            fileList[0]?.selectedFile &&
                            <Btn handleClick={() => handleFileSubmit()} width={"180px"} bgColor="#333" borderColor="transparent" color="#fff" padding="10px">Sevk İrsaliyesi Yükle</Btn>
                        }
                    </div>
                }
            
                </div>
            <div className="btn-container">
                <Btn handleClick={() => dispatch(showNestedModal(null))} width={"180px"} bgColor="#333" borderColor="transparent" color="#fff" padding="10px">Vazgeç</Btn>
            </div>
        </div>
    </Container>
  )
}

export default ShipmentRouteOperationModal